import React from "react";
import { IPagination, UtcTimePopover } from "../screenshots/screenshots.component";
import { addDays } from "../../utilities/date.utilities";
import SubHeader from "../../layout/components/sub-header/sub-header.component";
import ContentWrapper from "../../layout/components/content-wrapper/content-wrapper.component";
import { Card, Dropdown, OverlayTrigger } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import DatePicker from "react-datepicker";
import { UserSlimDisplay } from "../../components/user-slim-display/user-slim-display";
import { DateTimeDisplayUTC } from "../../components/date-time-display/date-time-display-utc.component";
import { getSessionsClient, getUserTagsClient, getWebinarsClient, getWebinarsSyncClient } from "../../services/api-clients.service";
import { ShowErrorFromResponse } from "../../utilities/response-processor";
import { Link, useHistory } from "react-router-dom";
import { DateTimeDisplay } from "../../components/date-time-display/date-time-display.component";
import { getTextBasedOnFeedbackScore } from "../feedbacks/feedbacks.component";

import { UserTagFilter } from "../../components/user-tag-filter/user-tag-filter.component";
import { _copyAndSort } from "../../utilities/array.helpers";
import SystemUserTagCodes from "../users/users.shared";
import { WebinarForListResponseModel } from "../../swagger-clients/s365-admin-panel-clients.service";
import EditWebinarModal from "./edit-webinar-modal.component";
import BootstrapTooltip from "../../components/bootstrap-tooltip/bootstrap-tooltip";
import { toast } from "react-toastify";
import SyncWebinarAttendanceProgressModal from "./sync-webinars-attendance-progress-modal.component";
import LoadingButton from "../../components/loading-button/loading-button.component";

type WebinarsPageProps = {

}



export const WebinarsPage: React.FC<WebinarsPageProps> = (props) => {
    const [webinars, setWebinars] = React.useState<WebinarForListResponseModel[]>([]);
    const [selectedWebinarId, setSelectedWebinarId] = React.useState<number>();
    const [showEditWebinarModal, setShowEditWebinarModal] = React.useState<boolean>(false);
    const [pagination, setPagination] = React.useState<IPagination>({
        currentPage: 1,
        recordsPerPage: 20,
        totalRecords: 0
    });
    const [nameFilter, setNameFilter] = React.useState<string>();
    const [orderBy, setOrderBy] = React.useState<string>("StartedAtUtc");
    const [orderByDescending, setOrderByDescending] = React.useState<boolean>(true);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [showSyncWebinarAttendenceProgressModal, setShowSyncWebinarAttendenceProgressModal] = React.useState<boolean>(false);
    React.useEffect(() => {
        getWebinars();
    }, [pagination.currentPage, pagination.recordsPerPage, orderBy, orderByDescending]);



    const getWebinars = async () => {
        try {
            setWebinars([]);
            setIsLoading(true);

            const { recordsPerPage, currentPage } = pagination;
            const client = getWebinarsClient();

            const webinarsResponse = await client.getWebinars(nameFilter, null, false, (currentPage - 1) * recordsPerPage, recordsPerPage);
            setWebinars(webinarsResponse?.items ?? []);
            setPagination(s => ({ ...s, totalRecords: webinarsResponse?.totalItems ?? 0 }));
        } catch (error) {
            ShowErrorFromResponse(error, "An error ocurred while getting webinars.");
        } finally {
            setIsLoading(false);
        }
    }


    const resetForm = () => {
        setNameFilter("");

    }

    const onColumnClick = (column: string) => {
        if (orderBy == column) {
            setOrderByDescending(!orderByDescending);
        } else {
            setOrderBy(column);
            setOrderByDescending(true);
        }
    }

    const getSortValue = (columnName: string) => {
        if (orderBy == columnName) {
            if (orderByDescending) {
                return "desc";
            } else {
                return "asc";
            }
        }
        return undefined;
    }

    const onSyncWebinarListClick = async () => {
        try {
            const client = getWebinarsClient();
            await client.syncWebinarsFromZoom();
            toast.success("Successfully synced webinars list from zoom.");
            await getWebinars();

        } catch (error) {
            ShowErrorFromResponse(error, "An error ocurred while syncing webinars list from zoom.");
        }
    }

    const onSyncAllWebinarsAttendanceClick = async () => {
        try {
            const client = getWebinarsSyncClient();
            await client.syncAllWebinars();
            setShowSyncWebinarAttendenceProgressModal(true);

        } catch (error) {
            ShowErrorFromResponse(error, "An error ocurred while syncing webinars attendance.");
        }
    }

    const onSyncSingleWebinarClick = async (webinarId: number) => {

        try {
            const client = getWebinarsSyncClient();
            await client.syncWebinar(webinarId);
            setShowSyncWebinarAttendenceProgressModal(true);

        } catch (error) {
            ShowErrorFromResponse(error, "An error ocurred while syncing webinar.");
        }

    }

    const { totalRecords, currentPage, recordsPerPage } = pagination;
    const totalPages = Math.ceil(totalRecords / recordsPerPage);
    const leftItems = [
        <div>
            <BootstrapTooltip tooltipText="Sync webinars from Zoom to local database" placement="top">
                <button className="btn btn-sm btn-primary" onClick={() => { onSyncWebinarListClick() }}>Sync webinars list</button>
            </BootstrapTooltip>
        </div>,
        <div>
            <BootstrapTooltip tooltipText="Sync webinars participants and registrants" placement="top">
                <button className="btn btn-sm btn-primary ml-2" onClick={() => { onSyncAllWebinarsAttendanceClick() }}>Sync webinars attendance</button>
            </BootstrapTooltip>
        </div>

    ]

    return <div> <SubHeader key="sub-header" title="Webinars" leftItems={leftItems} rightItems={[]} />
        <ContentWrapper key="content-wrapper" className="pl-4 pr-4">
            <Card className='mb-4' style={{ marginRight: "auto", marginLeft: "auto", width: "100%" }}>
                <div className="pt-3 pl-3 pr-3 mr-3 d-flex justify-content-between">
                    <form onSubmit={(ev) => { ev.preventDefault(); if (currentPage !== 1) { setPagination(s => ({ ...s, currentPage: 1 })); } else { getWebinars(); } }} action="">
                        <div className="form-row align-items-center">
                            <div className="col-auto" style={{ minWidth: "330px" }}>
                                <input type="text"
                                    name="nameFilter"
                                    className="form-control mb-2"
                                    onChange={e => setNameFilter(e.target.value)}
                                    placeholder="Webinar name" value={nameFilter} />
                            </div>



                            <div className="col-auto ml-2">
                                <button type="submit" className="btn btn-primary mb-2 mr-2" >Search</button>
                                <button type="button" className="btn btn-default mb-2" style={{ marginRight: '50px' }} onClick={() => resetForm()}> <i className="fas fa-eraser" /> </button>
                            </div>
                        </div>
                    </form>

                    <div>
                        <select className="form-control form-select" value={recordsPerPage} onChange={(event) => setPagination(s => ({ ...s, recordsPerPage: +event.target.value }))}>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                            <option value="500">500</option>
                            <option value="10000">1000</option>
                        </select>
                    </div>

                </div>
            </Card>
            <Card >
                <Card.Body>

                    <div className="">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Name</th>
                                    <th className="text-center">Created by</th>
                                    <th className="text-center">Event date</th>
                                    <th className="text-center">Recurring</th>
                                    <th className="text-center">Sync enabled</th>
                                    <th className="text-center"></th>
                                </tr>
                            </thead>
                            <tbody>

                                {webinars.map((item) =>
                                (<tr key={item.id} >
                                    <td>{item.id}</td>
                                    <td>{item.name}</td>
                                    <td className="text-center">{item.zoomUser}</td>
                                    <td className="text-center"><DateTimeDisplayUTC date={item.eventAt} /> </td>
                                    <td className="text-center">{item.isReoccurring ? "YES" : "NO"}</td>
                                    <td className="text-center">{item.isActive ? "YES" : "NO"}</td>
                                    <td className="text-center">
                                        <button type="button"
                                            className="btn btn-sm btn-primary"
                                            onClick={() => onSyncSingleWebinarClick(item.id)}>
                                            Sync
                                        </button>
                                        <button type="button"
                                            className="btn btn-sm btn-primary  ml-2"
                                            onClick={() => {
                                                setSelectedWebinarId(item.id);
                                                setShowEditWebinarModal(true);
                                            }}>Edit</button>
                                    </td>
                                </tr>))
                                }

                                {!!isLoading &&
                                    <tr>
                                        <td colSpan={5} className="text-center">Loading...</td>
                                    </tr>
                                }


                            </tbody>
                        </table>

                        {totalPages > 1 &&
                            <div className="d-flex align-items-center">
                                <ReactPaginate
                                    previousLabel={'previous'}
                                    nextLabel={'next'}
                                    breakLabel={'...'}
                                    breakClassName={'break-me page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    pageCount={totalPages}
                                    marginPagesDisplayed={4}
                                    pageRangeDisplayed={10}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'page-link'}
                                    forcePage={currentPage - 1}
                                    onPageChange={(page: any) => {
                                        console.log("Selected page:", page);
                                        setPagination(s => ({ ...s, currentPage: page.selected + 1 }));
                                        document.body.scrollTop = 0; // For Safari
                                        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                                    }}
                                    containerClassName={'pagination mb-0'}
                                    activeClassName={'active'}
                                />

                            </div>
                        }
                    </div>
                </Card.Body>
            </Card>
            {selectedWebinarId && showEditWebinarModal &&
                <EditWebinarModal
                    webinarId={selectedWebinarId}
                    show={true}
                    onSuccess={() => { setSelectedWebinarId(undefined); setShowEditWebinarModal(false); getWebinars(); }}
                    onHide={() => { setSelectedWebinarId(undefined); setShowEditWebinarModal(false); }}
                />}

            {showSyncWebinarAttendenceProgressModal &&
                <SyncWebinarAttendanceProgressModal show={true}
                    onHide={() => { setShowSyncWebinarAttendenceProgressModal(false); }}
                    onSuccess={() => { setShowSyncWebinarAttendenceProgressModal(false); }}
                />}
        </ContentWrapper></div>;
}